import { inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

/**
 * Language ('en' | 'ar') of the page being rendered, read from the router URL.
 *
 * Components used `location.pathname`, which does not exist during SSR, so on the server `lang`
 * was empty and canonical / hreflang / JSON-LD URLs of Arabic pages pointed at the English ones.
 * Must be called from an injection context (a constructor or field initializer).
 */
export function currentRouteLang(): 'en' | 'ar' {
  const match = /^\/(en|ar)(\/|$|\?|#)/i.exec(inject(Router).url);
  return match ? (match[1].toLowerCase() as 'en' | 'ar') : 'en';
}

/**
 * Same, but from the activated route: `:lang` lives on an ancestor of lazy-loaded category routes,
 * which `snapshot.parent` alone does not reach.
 */
export function routeLang(route: ActivatedRoute): string {
  const chain = route.snapshot.pathFromRoot;
  for (let i = chain.length - 1; i >= 0; i--) {
    const lang = chain[i].paramMap.get('lang');
    if (lang) return lang;
  }
  return 'en';
}
